import _capitalize from 'lodash.capitalize'

export const getNameInitials = (name: string): string => name
  .split(' ')
  .map(namePart => namePart.charAt(0))
  .join('')
  .toUpperCase()

export const upperCaseUnderscoreDelimitedToWords = (string: string): string => string
  .split('_').map(word => _capitalize(word))
  .join(' ')

export const isUuid = (string: string): boolean =>
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(string)
